import {
    GET_ORG_PROPERITES_COLLECTION,
    GET_ORG_PROPERITES_COLLECTION_SUCCESS,
    GET_ORG_PROPERITES_COLLECTION_FAILURE,
    GET_PROPERTY_BY_ID,
    GET_PROPERTY_BY_ID_SUCCESS,
    GET_PROPERTY_BY_ID_FAILURE,
    SET_PAGE_INDEX,
    SET_ROW_COUNT,
    SET_ACTIVE_USER_ORG,
    SET_ORGANIZATION_PROPERTY,
    IMPORT_ORG_PROPERITES,
    IMPORT_ORG_PROPERITES_SUCCESS,
    IMPORT_ORG_PROPERITES_FAILURE,
    RESET_IMPORT_ORG_PROPERITES
} from '../actions/types';

const INITIAL_STATE = {
    orgProperties: null,
    loadingOrgProperties: false,
    orgPropertiesError: null,
    addedProperties: null,
    loadingAddProperties: false,
    addPropertiesError: null,
    loading: false,
    propertyError: null,
    organizationProperty: null,
    propertyPage: 0,
    propertyRow: 10,
    error: null
};

const propertiesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ORG_PROPERITES_COLLECTION:
            return {
                ...state,
                orgProperties: null,
                loadingOrgProperties: true,
                orgPropertiesError: null
            };
        case GET_ORG_PROPERITES_COLLECTION_SUCCESS:
            return {
                ...state,
                orgProperties: action.payload,
                loadingOrgProperties: false,
                orgPropertiesError: null
            };
        case GET_ORG_PROPERITES_COLLECTION_FAILURE:
            return {
                ...state,
                orgProperties: null,
                loadingOrgProperties: false,
                orgPropertiesError: action.payload
            };
        case SET_ORGANIZATION_PROPERTY:
            return {
                ...state,
                organizationProperty: action.payload
            };
        case IMPORT_ORG_PROPERITES:
            return {
                ...state,
                addedProperties: null,
                loadingAddProperties: true,
                addPropertiesError: null
            };
        case IMPORT_ORG_PROPERITES_SUCCESS:
            return {
                ...state,
                addedProperties: action.payload,
                loadingAddProperties: false,
                addPropertiesError: null
            };
        case IMPORT_ORG_PROPERITES_FAILURE:
            return {
                ...state,
                addedProperties: null,
                loadingAddProperties: false,
                addPropertiesError: action.payload
            };
        case RESET_IMPORT_ORG_PROPERITES:
            return {
                ...state,
                addedProperties: null,
                loadingAddProperties: false,
                addPropertiesError: null
            };
        case GET_PROPERTY_BY_ID:
            return {
                ...state,
                property: null,
                loading: true
            };
        case GET_PROPERTY_BY_ID_SUCCESS:
            return {
                ...state,
                property: action.payload,
                loading: false,
                propertyError: null
            };
        case GET_PROPERTY_BY_ID_FAILURE:
            return {
                ...state,
                property: null,
                loading: false,
                propertyError: action.payload
            };
        case SET_PAGE_INDEX:
            return {
                ...state,
                propertyPage:
                    action.payload.type === 'units'
                        ? action.payload.value
                        : state.propertyPage
            };
        case SET_ROW_COUNT:
            return {
                ...state,
                propertyRow:
                    action.payload.type === 'units'
                        ? action.payload.value
                        : state.propertyRow
            };
        case SET_ACTIVE_USER_ORG:
            return {
                ...state,
                propertyPage: INITIAL_STATE.propertyPage,
                propertyRow: INITIAL_STATE.propertyRow
            };
        default:
            return state;
    }
};

export default propertiesReducer;
